export const checkIsDbsCoupon = (masterPass) => {
  return masterPass.content.description_json.dbsCouponMinutes != null;
}